function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { T, isEmpty, isNil } from 'ramda';
import Modal from '../Modal';
import { Container, Total, Table, Details, Row } from './components';
import { createCell } from './helpers';
var isBold = T();
export var isBlackListedRoute = function isBlackListedRoute(r, blacklistedRoutes) {
  return !isNil(r) && !isEmpty(r) ? blacklistedRoutes.filter(function (route) {
    return route === r;
  }).length !== 0 : false;
};

var PricingPopup = function (_Component) {
  _inherits(PricingPopup, _Component);

  function PricingPopup() {
    _classCallCheck(this, PricingPopup);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PricingPopup.prototype.render = function render() {
    var _props$config = this.props.config,
        products = _props$config.products,
        settings = _props$config.settings,
        heading = _props$config.heading,
        description = _props$config.description,
        price = _props$config.price;
    var theme = this.props.theme;
    return React.createElement(Modal, {
      show: this.props.show,
      handleClose: this.props.handleClose,
      title: this.props.title
    }, React.createElement(Container, {
      className: ''
    }, React.createElement(Total, null, React.createElement('h3', null, heading), React.createElement('p', null, description), React.createElement('p', null, price)), React.createElement(Details, {
      className: 'dropdown-open'
    }, React.createElement(Table, null, products.map(function (product) {
      var price = product.price,
          name = product.name;
      return React.createElement(Row, {
        key: name
      }, createCell(theme, {
        title: name,
        position: 'start'
      }), createCell(theme, {
        title: price,
        position: 'end',
        isBold: isBold
      }));
    }), settings.map(function (cells) {
      var left = cells.left,
          right = cells.right;
      return React.createElement(Row, {
        key: left.title
      }, createCell(theme, left), createCell(theme, right));
    })))));
  };

  return PricingPopup;
}(Component);

export default withTheme(PricingPopup);